import { clampVerticalTexts } from '@/functions';
import { owl } from 'commonComponents/image-visor/image-visor';

export default () => {
  const tabletSize = window.matchMedia("only screen and (min-width : 768px)");

  // funcion para dar margen al gallery header cuando los subtitulos se pintan fuera
  function giveMarginGalleryHeader(){
    if (tabletSize.matches) {
      $('.gallery-header-container').css('margin-bottom', $('span.header-subtitles')[0]?.clientHeight);
    }
    else {
      $('.gallery-header-container').css('margin-bottom', $('ul.gallery-header-description')[0]?.clientHeight);
    }
  }

  if ($('.gallery-header-container').length > 0) {
    giveMarginGalleryHeader();

    $(window).resize(function(){
      giveMarginGalleryHeader();
    });
  }

  $('.gallery-header-container .gallery-header:not(.video) .gallery-header-wrapper').click(function() {
    window.dataLayer.push({
      event: 'click_image',
      eventData: {
        im_location: 'principal',
        content_id: window.appInfo?.contentId ?? undefined
      }
    });

    window.location.hash = `#foto1`;
    owl.trigger('to.owl.carousel', 0);
  });

  owl.trigger('to.owl.carousel', 0);

  $('.gallery-header').off('click').click(function() {
    const imageVisor = $(this).find('.cmp-image-visor');
    if (imageVisor.length) {
      const adHeaderRow = imageVisor.closest('.row').prev('.row');
      if (adHeaderRow.length) {
        adHeaderRow.hide();
      }
      imageVisor.show();
      $('body').css("overflow-y", "hidden");

      setTimeout(function(){
        clampVerticalTexts('img');
      }, 500);
    }
  });
  //Para evitar que al hacer un click en un enlace se ejecute el video/galleria/etc
  $('.gallery-header li, .gallery-header a').off('click').click(function(e){
    e.stopPropagation();
  });
}
